import React, { ReactNode, Ref, forwardRef } from 'react';
import css from './Link.module.css';
import clsx from 'clsx';

export interface LinkPropsExt {
  tooltip?: string;
  disabled?: boolean;
  allowWrap?: boolean;
  onClick?: () => void;
}

export interface LinkProps extends LinkPropsExt {
  className?: string;
  children: ReactNode;
}

const LinkComponent: React.ForwardRefRenderFunction<
  HTMLAnchorElement,
  LinkProps
> = (props: LinkProps, ref: Ref<HTMLAnchorElement>) => {
  const { disabled = false } = props;
  const onClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ): boolean => {
    if (props.onClick) {
      event.preventDefault();
      props.onClick();
    }

    return false;
  };
  return (
    <div
      className={clsx(
        css.selectionBorder,
        props.allowWrap === false ? css.preventWrap : null
      )}
    >
      <a
        // the href allows the anchor to recieve focus
        // javascript:void(0) prevents default behavior with the anchor tag
        href=""
        ref={ref}
        className={clsx(
          props.className,
          css.link,
          disabled ? css.disabled : null
        )}
        type="button"
        onClick={onClick}
        title={props.tooltip}
      >
        {props.children}
      </a>
    </div>
  );
};

const Link = forwardRef(LinkComponent);

export default Link;
